import { render, staticRenderFns } from "./OperaRoleChangeWindow.vue?vue&type=template&id=7d4e2f2c&scoped=true"
import script from "./OperaRoleChangeWindow.vue?vue&type=script&lang=js"
export * from "./OperaRoleChangeWindow.vue?vue&type=script&lang=js"
import style0 from "./OperaRoleChangeWindow.vue?vue&type=style&index=0&id=7d4e2f2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4e2f2c",
  null
  
)

export default component.exports